import api from "../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY;

const toVarchar = (date) => {
    if (!date) return undefined;
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
};

export const getVacacionesOperadores = async (desde, hasta) => {
    try {
        const params = new URLSearchParams();
        if (desde) params.append('desde', toVarchar(desde));
        if (hasta) params.append('hasta', toVarchar(hasta));
        const result = await api.get(`${urlApi}/talentoHumano/vacaciones-operadores?${params}`);
        return result.data;
    } catch (error) {
        console.log('error', error);
        throw error;
    }
};
